import { all } from "redux-saga/effects";
import formActionSaga from "redux-form-saga";

import Motoristas from "./Motoristas";
import Destinatarios from "./Destinatarios";
import Remetentes from "./Remetentes";
import Romaneios from "./Romaneios";
import Cte from "./Cte";
import Auditoria from "./Auditoria";
import Protocolos from "./Protocolos";
import Notas from "./Notas";
import Distribuidoras from "./Distribuidoras";
import Pesquisar from "./Pesquisar";
import PrazoEntrega from "./PrazoEntrega";
import Empresa from "./Empresa";

export default function* rootSaga(getState) {
    yield all([
        formActionSaga(),
        Motoristas(),
        Destinatarios(),
        Remetentes(),
        Romaneios(),
        Cte(),
        Auditoria(),
        Protocolos(),
        Notas(),
        Distribuidoras(),
        Pesquisar(),
        PrazoEntrega(),
        Empresa(),
    ]);
}
